<template>
  <BaseMenu
    :placement="'bottom'"
    :offset="[0,0]"
    :appendToBody="true"
  >
    <button id="module-btn" class="module-button">
      <SVGIcon
        :height="'32px'"
        :width="'32px'"
        :iconName="'apps'"
        :showHover="false"
        :showActive="true"
      />
    </button>
    <template #menu="{closeMenu}">
      <div id="module-menu" class="module-menu">
        <ul>
          <li>
            <BaseMenuButton
              :id="'module-menu__projects'"
              @click="Project(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'folder2'"
                />
                <div class="li-text">
                  <div class="li-text__title">Projects</div>
                  <div class="li-text__description">Manage projects</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li>
            <BaseMenuButton
              :id="'module-menu__datasets'"
              :disabled="!currentProject"
              @click="Dataset(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'database2'"
                />
                <div class="li-text">
                  <div class="li-text__title">Datasets</div>
                  <div class="li-text__description">Curate, upload, and share datasets</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li>
            <BaseMenuButton
              :id="'module-menu__edit-audit-annotations'"
              :disabled="!currentProject"
              @click="AuditTasks(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'tag'"
                />
                <div class="li-text">
                  <div class="li-text__title">Auditing Tasks</div>
                  <div class="li-text__description">Manage labelling, audit, and more</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li>
            <BaseMenuButton
              :id="'module-menu__trainer'"
              :disabled="!currentProject"
              @click="Trainer(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'science'"
                />
                <div class="li-text">
                  <div class="li-text__title">Model Experiments</div>
                  <div class="li-text__description">Train and validate models</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <!-- <li>
            <BaseMenuButton
              :id="'module-menu__validate-sessions'"
              @click="Validator(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'compare'"
                />
                <div class="li-text">
                  <div class="li-text__title">Validate Sessions</div>
                  <div class="li-text__description">Compare model outputs</div>
                </div>
              </div>
            </BaseMenuButton>
          </li> -->
          <!-- <li>
            <BaseMenuButton
              @click="Automation(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'auto_annotate'"
                />
                <div class="li-text">
                  <div class="li-text__title">Automation</div>
                  <div class="li-text__description">AI assisted annotation & segmentation</div>
                </div>
              </div>
            </BaseMenuButton>
          </li> -->
          <li>
            <BaseMenuButton
              :id="'module-menu__cloud-instances'"
              @click="Servers(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'cloud_servers'"
                />
                <div class="li-text">
                  <div class="li-text__title">Cloud Instances</div>
                  <div class="li-text__description">Manage virtual servers</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li>
            <BaseMenuButton
              :id="'module-menu__snapshots'"
              @click="Snapshots(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'database_sync'"
                />
                <div class="li-text">
                  <div class="li-text__title">Data Snapshots</div>
                  <div class="li-text__description">Save and restore data</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
          <li>
            <BaseMenuButton
              id="module-menu__apps"
              @click="Apps(); closeDrawer()"
            >
              <div class="li-row">
                <SVGIcon width="28px" height="28px" iconName="play_circle" />
                <div class="li-text">
                  <div class="li-text__title">Apps</div>
                  <div class="li-text__description">Custom Processes</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>

          <li>
            <BaseMenuButton
              :id="'module-menu__tasks'"
              @click="Tasks(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'database_sync'"
                />
                <div class="li-text">
                  <div class="li-text__title">Tasks</div>
                  <div class="li-text__description">Background running tasks</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>



        </ul>
        <hr>
        <ul>
          <li>
            <BaseMenuButton
              :id="'module-menu__recycle'"
              @click="RecycleBin(), closeMenu()"
            >
              <div class="li-row">
                <SVGIcon
                  :width="'28px'"
                  :height="'28px'"
                  :iconName="'trash'"
                />
                <div class="li-text">
                  <div class="li-text__title">Recycle Bin</div>
                  <div class="li-text__description">Manage removed items</div>
                </div>
              </div>
            </BaseMenuButton>
          </li>
        </ul>
      </div>
    </template>
  </BaseMenu>
</template>

<script>
import BaseMenu from '@/components/BaseMenu.vue';
import SVGIcon from '@/components/SVGIcon.vue';
import BaseMenuButton from '@/components/BaseMenuButton.vue';
import {
  goto_projects,
  goto_datasets,
  goto_experiments,
  goto_taskboard,
  goto_servers,
  goto_snapshots,
  goto_recycle_bin,
  goto_apps,
  goto_tasks,
} from '@/assets/js/links.js';

export default {
  name: 'ModuleMenuV2',
  components: {
    SVGIcon,
    BaseMenu,
    BaseMenuButton,
  },
  computed: {
    currentProject() {
      return this.$store.state.projects.currentProject;
    },
  },
  methods: {
    Trainer() {
      if (this.currentProject) {
        goto_experiments(this.currentProject.id);
      }
    },
    Project() {
      goto_projects();
    },
    Dataset() {
      if (this.currentProject) {
        goto_datasets(this.currentProject.id);
      }
    },
    Automation() {
      // TODO: Add goto_automation if available
      console.warn('Automation not yet implemented');
    },
    AuditTasks() {
      if (this.currentProject) {
        goto_taskboard(this.currentProject.id);
      }
    },
    Servers() {
      goto_servers();
    },
    RecycleBin() {
      goto_recycle_bin();
    },
    Snapshots() {
      goto_snapshots();
    },
    Apps() {
      goto_apps();
    },
    Tasks() {
      goto_tasks();
    },
  },
};
</script>

<style lang="scss" scoped>

.module-button {
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  background: none;
  border: none;
  cursor: pointer;
  @include themify() {
    color: themed('header-dot-menu');
  }

  &:hover {
    @include themify() {
      background: themed('header-button-background-hover');
      color: themed('header-button-color-hover');
    }
  }

  &._active {
    @include themify() {
      background: themed('header-button-background-hover');
      color: themed('header-button-color-hover');
    }
  }
}

.li-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.li-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &__title{
    display: flex;
    font-size: 1rem;
    font-weight: 600;
    margin-left: 12px;
  }

  &__description{
    display: flex;
    font-size: 0.8rem;
    font-weight: 600;
    margin-left: 12px;
    margin-top: 5px;
    text-align: left;
    @include themify() {
      color: rgba(61, 60, 60, 0.5);
    }
  }
}
.module-menu {
  width: 290px;
}
</style>
